function cov_1ergbcc93w() {
  var path = "/app/src/types/theme-type.ts";
  var hash = "aaea8a71a7ad9f377bed24fe6f3540c140309c9f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/theme-type.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 25
        },
        end: {
          line: 3,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aaea8a71a7ad9f377bed24fe6f3540c140309c9f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ergbcc93w = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ergbcc93w();
export var ThemeType = (cov_1ergbcc93w().s[0]++, {
  default: 'default'
});